/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SnackbarView.scss'
import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Snackbar from './atoms/alert/Snackbar'

function SnackbarView(props) {
  const messages = props.snackbar.messages

  return (
    <TransitionGroup id="SnackbarContainer" className="SnackbarView">
      {messages &&
        messages.map((m, i) => (
          <CSSTransition classNames="fade" timeout={4000} key={i}>
            <Snackbar key={i} type={m.type} fadeout={m.fadeout}>
              {m.message}
            </Snackbar>
          </CSSTransition>
        ))}
    </TransitionGroup>
  )
}
export default SnackbarView
